export const DELETE = "delete";
export const CREATE = "create";
export const UPDATE = "update";
export const READ = "read";
